<template>
  <v-row justify="center">
    <v-dialog v-model="toggleForm" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <h1>Promocode</h1>
        </v-card-title>
        <v-card-text>
          <v-container>
            <!-- General -->
            <h3>General</h3>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Code*"
                  v-model="localValue.general.code"
                  required
                  :disabled="editingPromocode"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Name"
                  v-model="localValue.general.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="localValue.general.description">
                  <template v-slot:label>
                    <div>
                      Description
                    </div>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <hr />
            <br />
            <br />

            <!-- Discount -->
            <v-col cols="12">
              <v-checkbox
                v-model="localValue.discount.isAvailable"
                label="Enable First Payment Discount"
                required
              ></v-checkbox>
            </v-col>
            <h3 v-if="localValue.discount.isAvailable" class="mb-heading-pc">
              Discount
            </h3>
            <br />
            <v-row v-if="localValue.discount.isAvailable">
              <v-col cols="12" sm="6">
                <v-text-field
                  type="number"
                  label="Amount"
                  v-model="localValue.discount.amount"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  :items="type"
                  label="Type*"
                  v-model="localValue.discount.type"
                ></v-select>
              </v-col>
            </v-row>
            <hr />
            <br />
            <br />

            <!-- Recurring -->
            <v-col cols="12">
              <v-checkbox
                v-model="localValue.recurring.isAvailable"
                label="Enable Free Trials or Recurring Discounts"
                required
              ></v-checkbox>
            </v-col>
            <h2 v-if="localValue.recurring.isAvailable" class="mb-heading-pc">
              Recurring
            </h2>
            <v-row v-if="localValue.recurring.isAvailable">
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="localValue.recurring.discount.isAvailable"
                  label="Enable Recurring Discount"
                  required
                ></v-checkbox>
              </v-col>
              <hr />
              <v-row v-if="localValue.recurring.discount.isAvailable">
                <!-- Recurring Discount -->
                <v-col cols="12"><h3>Recurring Discount</h3></v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    type="number"
                    label="Amount"
                    v-model="localValue.recurring.discount.amount"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    :items="type"
                    label="Type*"
                    v-model="localValue.recurring.discount.type"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- Recurring Free Trials -->
              <v-col
                cols="12"
                style="display:flex; justify-content: space-between;"
                ><h3 class="mb-heading-pc">Free Trials</h3>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" @click="addFreeTrial">
                      <i class="fa-regular fa-plus fa-xl"></i>
                    </v-btn>
                  </template>
                  <span>Add Free Trial</span>
                </v-tooltip>
              </v-col>
              <v-row
                style="display: flex; align-items: center; padding: 1rem"
                v-for="(item, i) in localValue.recurring.freeTrials"
                :key="i"
              >
                <v-col cols="12" sm="6">
                  <v-select
                    name="Frequency"
                    :items="recurringPaymentFrequencies"
                    label="Frequency"
                    v-model="item.frequency"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    type="number"
                    label="Period"
                    v-model="item.period"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="color: #ED561B; width: 100%;"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="removeFreeTrial(i)"
                      >
                        <i class="fa-regular fa-x fa-lg"></i>
                      </v-btn>
                    </template>
                    <span>Remove Free Trial</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-row>
            <hr />
            <br />
            <br />

            <!-- Requirement -->
            <v-col cols="12">
              <v-checkbox
                v-model="localValue.requirements.isAvailable"
                label="Enable Requirements"
                required
              ></v-checkbox>
            </v-col>
            <h3 v-if="localValue.requirements.isAvailable">Requirement</h3>
            <v-row v-if="localValue.requirements.isAvailable">
              <v-col cols="12" sm="12">
                <v-text-field
                  type="email"
                  name="Customer Email"
                  label="Customer Email"
                  v-model="localValue.requirements.customerEmail"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <label for="start-date">Start Date</label>
                <b-form-datepicker
                  id="start-date"
                  v-model="localValue.requirements.startDate"
                ></b-form-datepicker>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="end-date">End Date</label>
                <b-form-datepicker
                  id="end-date"
                  v-model="localValue.requirements.endDate"
                ></b-form-datepicker>
              </v-col>
            </v-row>
            <hr />
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeForm">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="savePromocode">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import PromocodePermissionsMixin from "./PromocodePermissionsMixin";
import { createPromoCode, updatePromoCode } from "../../graphql/mutations";
import dayjs from "dayjs";
export default {
  mixins: [PromocodePermissionsMixin],
  name: "PromocodeModal",
  props: {
    editingPromocode: {
      type: Boolean,
      required: false
    },
    toggleForm: {
      type: Boolean,
      required: true
    },
    value: {
      type: Object,
      required: true,
      default: () => {
        return {
          general: {
            name: "",
            code: "",
            description: ""
          },
          discount: {
            isAvailable: false,
            amount: 0,
            type: "Fixed"
          },
          requirements: {
            isAvailable: false,
            startDate: new Date(),
            endDate: new Date(),
            customerEmail: ""
          },
          recurring: {
            isAvailable: false,
            discount: {
              isAvailable: false,
              amount: 0,
              type: "Fixed"
            },
            freeTrials: []
          }
        };
      }
    }
  },
  data() {
    return {
      type: ["Percentage", "Fixed"],
      recurringPaymentFrequencies: [
        "Daily",
        "Weekly",
        "Fortnightly",
        "Monthly",
        "BiMonthly",
        "Quarterly",
        "Yearly"
      ]
    };
  },
  watch: {
    localValue: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  computed: {
    localValue() {
      return this.value;
    },
    promocodeInput() {
      return {
        ...this.localValue.general,
        discount: this.localValue.discount,
        requirements: {
          ...this.localValue.requirements,
          startDate: this.formattedDate(this.localValue.requirements.startDate),
          endDate: this.formattedDate(this.localValue.requirements.endDate)
        },
        recurring: this.localValue.recurring
      };
    }
  },
  methods: {
    addFreeTrial() {
      this.localValue.recurring.freeTrials.push({
        frequency: this.recurringPaymentFrequencies[0],
        period: 1
      });
    },
    removeFreeTrial(i) {
      this.localValue.recurring.freeTrials.splice(i, 1);
    },
    async createCode() {
      try {
        const promocodeBody = this.promocodeInput;

        this.validatePromoCode(promocodeBody);

        const { data } = await API.graphql({
          ...graphqlOperation(createPromoCode, { body: promocodeBody })
        });

        if (!data.createPromoCode.success) {
          throw new Error("Something went wrong creating code");
        }
        this.clearForm();
        this.createToast("success", "Promo Code created successfully");
      } catch (error) {
        this.$logger.error(error);
        this.createToast(
          "danger",
          error.message ?? "Something went wrong creating code"
        );
      }
    },
    async editCode() {
      try {
        const promocodeBody = this.promocodeInput;
        this.validatePromoCode(promocodeBody);
        const id = promocodeBody.id;
        delete promocodeBody.id;
        const { data } = await API.graphql({
          ...graphqlOperation(updatePromoCode, {
            body: promocodeBody,
            id: id
          })
        });
        if (!data.updatePromoCode.success) {
          throw new Error("Something went wrong updating code");
        }
        this.clearForm();
        this.$emit("closeEditing");
        this.createToast("success", "Promo Code updated successfully");
      } catch (error) {
        this.$logger.error(error);
        this.createToast(
          "danger",
          error.message ?? "Something went wrong updating code"
        );
      }
    },
    async savePromocode() {
      if (!this.canEditOrCreatePromocodes) {
        this.createToast("danger", "Not allowed to Edit or Create Promocode");
        return;
      }
      if (this.editingPromocode) {
        await this.editCode();
      } else {
        await this.createCode();
      }
      this.$emit("updatePromotionalCodes");
    },
    validatePromoCode(promocode) {
      if (promocode.code.trim() == "") {
        throw new Error("Promo Code Invalid");
      }

      if (promocode.discount.isAvailable && promocode.discount.amount <= 0) {
        throw new Error("Discount must be greater than 0");
      }

      if (
        promocode.requirements.isAvailable &&
        dayjs(promocode.requirements.endDate).isBefore(
          promocode.requirements.startDate
        )
      ) {
        throw new Error("Start Date must be before End Date");
      }

      if (
        promocode.recurring.discount.isAvailable &&
        promocode.recurring.discount.amount <= 0
      ) {
        throw new Error("Recurring Discount must be greater than 0");
      }
      if (promocode.recurring.isAvailable)
        this.validatFreeTrials(promocode.recurring.freeTrials);
    },
    validatFreeTrials(freeTrials) {
      let testArray = [];
      for (let i of freeTrials) {
        if (testArray.includes(i.frequency)) {
          throw new Error(
            "Duplication Frequencies not allowed for free trials"
          );
        }
        testArray.push(i.frequency);
      }
    },
    formattedDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    createToast(variant, message) {
      this.$bvToast.toast(message, {
        title: "Promo Code Settings",
        autoHideDelay: 5000,
        variant,
        append: true
      });
    },
    clearForm() {
      this.localValue.general = {
        name: "",
        code: "",
        description: ""
      };
      this.localValue.discount = {
        isAvailable: false,
        amount: 0,
        type: "Fixed"
      };
      this.localValue.requirements = {
        isAvailable: false,
        startDate: new Date(),
        endDate: new Date(),
        customerEmail: ""
      };
      this.localValue.recurring = {
        isAvailable: false,
        discount: {
          isAvailable: false,
          amount: 0,
          type: "Fixed"
        },
        freeTrials: [{ frequency: "Daily", period: 1 }]
      };
    },
    closeForm() {
      this.$emit("closeForm");
      this.$emit("closeEditing");
      this.clearForm();
    }
  }
};
</script>

<style scoped>
.mb-heading-pc {
  margin-bottom: 1rem;
}
</style>
